/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************!*\
  !*** ./scripts/common.js ***!
  \***************************/
// Brand Filter
var filterNavItems = document.querySelectorAll(".grid-filter ul li");
var filterReset = document.querySelector('.grid-filter ul li[data-reset="reset"]');
var brandList = document.querySelectorAll(".brands-list li");
filterNavItems.forEach(function (item) {
  item.addEventListener("click", function () {
    var filterData = item.getAttribute("data-filter");
    var matchingBrands = document.querySelectorAll('.brands-list li[data-filter="' + filterData + '"]');
    if (filterData == "all") {
      Array.from(filterNavItems).forEach(function (el) {
        return el.classList.remove("active");
      });
      Array.from(brandList).forEach(function (el) {
        return el.classList.remove("hide");
      });
      item.classList.add("active");
    } else {
      Array.from(filterNavItems).forEach(function (el) {
        return el.classList.remove("active");
      });
      Array.from(brandList).forEach(function (el) {
        return el.classList.add("hide");
      });
      Array.from(brandList).forEach(function (el) {
        return el.classList.remove("show");
      });
      item.classList.add("active");
      console.log(filterData);
      //matchingBrands.classList.add('show');
      Array.from(matchingBrands).forEach(function (el) {
        return el.classList.add("show");
      });
    }
    console.log(filterData);
  });
});

// Tab Navigation

var tabItems = document.querySelectorAll(".tab-nav .tablinks");
tabItems.forEach(function (item) {
  item.addEventListener("click", function () {
    var tabData = item.getAttribute("data-tab");
    openTab(tabData);
    console.log(tabData);
  });
});
function openTab(tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  event.target.className += " active";
}

// close filter with the clear filter button
if (document.body.contains(document.querySelector(".mobile-facets__clear"))) {
  var filterCloseBtns = document.querySelectorAll(".mobile-facets__clear");
  filterCloseBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      btn.closest(".mobile-facets__wrapper").querySelector("summary").click();
    });
  });
}

// product grid layout switch
if (document.body.contains(document.querySelector(".layout-switch"))) {
  var facetsWrap = document.querySelector(".facets-vertical"),
    twoColBtn = document.querySelector('[data-switch="two-col"]'),
    oneColBtn = document.querySelector('[data-switch="one-col"]');
  oneColBtn.addEventListener("click", function (e) {
    e.target.classList.add("active");
    twoColBtn.classList.remove("active");
    facetsWrap.classList.add("single-col");
  });
  twoColBtn.addEventListener("click", function (e) {
    twoColBtn.classList.add("active");
    oneColBtn.classList.remove("active");
    facetsWrap.classList.remove("single-col");
  });
}

// Recommended products options pop up
document.addEventListener("click", function (e) {
  var target = e.target.closest(".complementary-pdt-variant-btn"); // Or any other selector.

  if (target) {
    var optionPdtId = target.getAttribute("data-product-id");
    var optionVId = target.getAttribute("data-variant-id");
    var relatedProductForm = document.getElementById('.complementary-products li[data-comp-product-id="' + optionPdtId + '"]');
    var containerId = document.getElementById("comp-product-" + optionPdtId + "");
    var requiredInput = containerId.querySelector(".product-variant-id");
    var optionParent = target.closest(".option-values");
    var optionSiblings = optionParent.querySelectorAll(".option-variant");
    requiredInput.value = optionVId;
    optionSiblings.forEach(function (sibling) {
      sibling.classList.remove("active");
    });
    target.classList.add("active");
  }
});
filterHeight = function filterHeight() {
  var collectionhero = document.querySelector(".collection-hero");
  var collectionHeroHeight = parseInt(collectionhero ? collectionhero.offsetHeight : 0);
  document.documentElement.style.setProperty("--collectionHero-height", "".concat(collectionHeroHeight, "px"));
};
filterHeight();
function handleWinResize() {
  // Resize code here
  filterHeight();
}
var resizeTimer;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(handleWinResize, 250);
});

// brands mobile menu issue fix (lang-specific)
document.querySelector("summary#HeaderDrawer-brands").addEventListener("click", function () {
  var brandsDetails = document.getElementById("Details-menu-drawer-brands-brands");
  if (brandsDetails) {
    brandsDetails.setAttribute("open", "");
    brandsDetails.setAttribute("open-brand", "");
    brandsDetails.style.transition = "opacity 0.3s";
    brandsDetails.style.opacity = 0;
    // Ensure the browser applies the transition:
    requestAnimationFrame(function () {
      brandsDetails.style.opacity = 1;
    });
  }
});
document.querySelector("#Details-menu-drawer-container .header__icon").addEventListener("click", function (e) {
  var _e$target$closest;
  // Check if immediate parent has the open attribute
  var immediateParent = (_e$target$closest = e.target.closest(".header__icon")) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.parentElement;
  if (!immediateParent || !immediateParent.hasAttribute("open")) {
    return;
  }
  var brandsDetails = document.getElementById("Details-menu-drawer-brands-brands");
  // Check if brandsDetails exists and has the open attribute
  if (!brandsDetails.hasAttribute("open-brand")) {
    return;
  }
  var brandsCloseBtn = document.querySelector("#link-brands .menu-drawer__close-button");
  brandsDetails.style.opacity = 0;
  if (brandsCloseBtn) {
    brandsCloseBtn.click();
    brandsDetails.removeAttribute("open-brand");
  }
});
/******/ })()
;